import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {UntilDestroy} from "@ngneat/until-destroy";
import {
  CreateModifierGroupRequest,
  DisplayedProduct,
  ModifierGroupInfo,
  ModifierProductInfo,
  NameTranslationType, UpdateModifierGroupRequest
} from "app/models/menu.model";
import { Organization } from 'app/models/organization.model';
import {ModifierGroupApiService} from "app/services/menu-edit/modifier-group-api.service";
import {BaseModalComponent} from "app/shared/base-modal/base-modal.component";
import {
  SelectModifiersModalComponent, SelectModifiersModalData
} from "app/pages/menu-edit/modifier-group/select-modifiers-modal/select-modifiers-modal.component";

@UntilDestroy()
@Component({
  selector: 'app-modifier-group-modal',
  templateUrl: './modifier-group-modal.component.html',
  styleUrls: ['./modifier-group-modal.component.scss']
})
export class ModifierGroupModalComponent extends BaseModalComponent implements OnInit {

  constructor(
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<ModifierGroupModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ModifierGroupModalData,
    private modifierGroupApiService: ModifierGroupApiService,
  ) {
    super(dialogRef);
  }

  mgName: string;
  description: string;
  nameTranslations: NameTranslationType;
  descriptionTranslations: NameTranslationType;
  modifierProducts: ModifierProductInfo[];

  ngOnInit(): void {
    this.mgName = this.data.modifierGroup?.name ?? '';
    this.description = this.data.modifierGroup?.description ?? '';
    this.nameTranslations = this.data.modifierGroup?.nameTranslations ?? {};
    this.descriptionTranslations = this.data.modifierGroup?.descriptionTranslations ?? {};
    this.modifierProducts = this.data.modifierGroup?.modifierProducts ?? [];
  }

  onClickSelectModifiers(){
    const modifierIds = this.data.modifierGroup.modifierProducts.reduce((accum: string[], m) => {
        accum.push(m.modifierId);
        return accum;
      },
      []);
    const modifiers =  [...this.data.modifiers.values()];
    this.dialog.open(SelectModifiersModalComponent, {
      data: {
        title: 'select modifiers',
        modifiers: modifiers,
        modifierIds: modifierIds,
      } as SelectModifiersModalData,
    }).afterClosed().subscribe(
      result => {
        if(result){
          this.modifierProducts = [];
          for (const modifierId of result) {
            this.modifierProducts.push({modifierId: modifierId} as ModifierProductInfo);
          }
        }
      }
    );
  }

  async onSubmit() {
    const updateRequestBody : UpdateModifierGroupRequest = {
      name: this.mgName,
      description: this.description,
      nameTranslations: this.nameTranslations,
      descriptionTranslations: this.descriptionTranslations,
      modifierProducts: this.modifierProducts,
      organizationId: this.data.organization.id,
    };

    if(this.data.modifierGroup?.id){
      const result = await this.modifierGroupApiService.updateModifierGroupAsync(this.data.modifierGroup.id, updateRequestBody);
      this.exit(result);
    } else {
      const createRequestBody : CreateModifierGroupRequest = {
        ...updateRequestBody,
        organizationId: this.data.organization.id,
      };
      const result = await this.modifierGroupApiService.createModifierGroupAsync(createRequestBody);
      this.exit(result);
    }
  }

  GetModifierName(modifierId: string): string {
    return this.data.modifiers.get(modifierId)?.name ?? modifierId;
  }
}

export interface ModifierGroupModalData {
  modifierGroup: ModifierGroupInfo,
  modifiers: Map<string, DisplayedProduct>,
  organization: Organization,
}
